import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchProducts } from "../../../services/products";

const iPhoneWidth = 430
export default function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [searchParams, setSearchParams] = useSearchParams();
    const data = props.data


    const [banner1Idx, setBanner1Idx] = useState(1)
    const [isExpandContent, setisExpandContent] = useState(false)
    const [filter, setFilter] = useState('')

    useEffect(() => {
        if (props.data?.tags?.[0]) {
            setFilter(props.data?.tags?.[0])
            fetchTShopProducts()
        }
    }
        , [props.data])


    const [products, setproducts] = useState([])
    const fetchTShopProducts = async () => {
        if (!props.data?._id) return
        let result = await fetchProducts({ isTcoin: true, partnerId: props.data?._id }, { limit: 12, sort: { order: -1 } })
        if (result?.result) setproducts(result?.result || []);
    }

    const [filteredProducts, setfilteredProducts] = useState([])
    const fetchTShopFilteredProducts = async () => {
        if (!props.data?._id) return
        let result = await fetchProducts({ isTcoin: true, partnerId: props.data?._id, 'tags': filter }, { sort: { order:-1 } })
        if (result?.result) setfilteredProducts(result?.result || []);
    }

    useEffect(() => {
        if (filter) {
            fetchTShopFilteredProducts()
        }
    }, [filter])

    const getHeroImages = () => {
        return data.heros || [data.hero]
    }


    return (
        <div className="relative h-full w-full flex flex-col items-center justify-start bg-[#999] p-[16px] gap-[16px]" style={{ overflowY: 'auto' }}>

            <div className="border-[4px] border-[#666] rounded-[16px] " style={{ width: iPhoneWidth, backgroundColor: "#F3F8FB" }}>

                <div className='w-full p-[16px] flex flex-row items-ends justify-between' style={{}}>
                    <div className='flex flex-row items-center justify-start' style={{}}>
                        <BackSvg text='返回' />
                        <div className='self-end text-[#6E604C] text-[12px] font-[300] ml-[8px] mb-[3px]'>返回</div>
                    </div>
                    <div className='flex flex-1 flex-row items-end justify-end' style={{ gap: 12 }}>
                        <StarSvg />
                        <ShoppingBagSvg />
                    </div>
                </div>

                <div className='w-full items-center justify-center text-center'>
                    <div className='text-black font-bold text-[18px]'>{data?.name || ''} - 網上商店</div>
                </div>
                <div className='w-full' style={{ overflow: 'hidden' }}>
                    <div className="w-full mt-[16px] relative" style={{ height: undefined, aspectRatio: 431 / 149 }}>
                        <img src={getHeroImages()[0]} className='w-full h-full' style={{ objectFit: 'cover', height: undefined, aspectRatio: 431 / 149 }} />

                        <div className='w-[40px] h-[19px] bg-[#000000] rounded-full flex items-center justify-center absolute bottom-[8px] right-[16px] z-[2]'>
                            <div className='text-white text-[10px] font-normal'>{banner1Idx} / {getHeroImages().length}</div>
                        </div>
                    </div>
                </div>
                {/*hero banner*/}
                {isExpandContent &&
                    <div className='mt-[16px] flex-col w-full p-[16px]'>
                        {data?.content?.map((c, ci) =>
                            c.type === 'text' ? <div key={ci} className='my-[8px]' style={{ color: c?.isTitle ? '#6E604C' : "#473F3A", fontWeight: c?.isTitle ? 700 : 400, fontSize: c?.isTitle ? 18 : 12 ,whiteSpace:'pre-line'}}>{c?.data || ''}</div>
                                : c.type === 'image' ? 
                                    <div key={ci} className='w-full flex flex-row' style={{ justifyContent: c?.justifyContent || 'center', width: '100%' }}>
                                        <img src={c?.url} className='my-[16px]' style={{ objectFit: 'cover', height: undefined, aspectRatio: c.aspectRatio || (389 / 204), width: c.width || '100%' }} />
                                    </div> 
                                : <div key={ci} />
                        )}
                    </div>
                }
                <div className='flex w-full items-center justify-center flex-row py-[8px] cursor-pointer' onClick={() => { setisExpandContent(p => !p) }}>
                    <div className='text-[#938474] font-bold text-[12px]'>關於{data?.name || ''}</div>
                    <DownArrowSvg />
                </div>
                <div className='w-full bg-black h-[9px] opacity-[0.05]' />

                {/*火熱商品*/}
                <div className='w-full items-start justify-start p-[16px]'>
                    <div className='text-[#6E604C] font-bold text-[16px]'>火熱商品</div>
                </div>
                <div className='w-full'>
                    <div style={{ overflowX: 'auto' }} className='w-full pl-[16px] flex flex-row items-stretch justify-start'>
                        {products.map((item, index) =>
                            <div key={item?._id || index} style={{ width: 120 }}
                                className='relative flex flex-col min-w-[122px] w-[122px] flex flex-col items-center mr-[12px] border border-[white] border-[.5px] rounded-xl'
                            >
                                <div className='absolute bottom-0 left-0 right-0 top-0 rounded-xl' style={{ background: 'linear-gradient(180deg, #FFFFFF10 70%, #FFFFFF 100%)' }} />
                                <img src={item?.thumbnail || item?.img} className='w-full rounded-xl' style={{ objectFit: 'cover', height: 120, borderRadius: 8 }} />
                                <div className='flex w-full flex-col p-[4px] flex-1' style={{}}>
                                    <div className='text-black text-[10px] py-[8px] font-normal flex-1'>{item.name || item?.label || '-'}</div>
                                    <div className='flex relative w-full flex-row items-center gap-[4px]'>
                                        <CreditSvg />
                                        <div className='text-[#1C3D70] font-bold text-[20px]'>{item?.price || ''}</div>
                                    </div>
                                </div>
                            </div>)
                        }
                    </div>
                </div>
                {products.length === 0 &&
                    <div className='flex w-full justify-center items-center py-[24px]'>
                        <img className='w-[205px] h-[168px]' src='https://t-gather.s3.ap-southeast-1.amazonaws.com/images/shops/comingsoon.png' />
                    </div>
                }
                {/*火熱商品*/}

                {data?.hero2 && <img src={data?.hero2} className='w-full mt-[16px]' style={{ objectFit: 'cover', height: undefined, aspectRatio: data?.hero2AspectRatio || (430 / 242) }} />}


                {data?.tags && <div className='relative flex w-full flex-row gap-[8px] mt-[16px] px-[16px]'>
                    <div className='absolute bottom-0 left-0 right-0 top-0' style={{ background: 'linear-gradient(180deg, #FFFFFF30 0%, #FFFFFF 100%)' }} />
                    {data?.tags?.map((item, index) =>
                        <div onClick={() => { setFilter(item) }} className='min-w-[30px] cursor-pointer flex-col flex items-center justify-center z-[1]' style={{ paddingTop: 6 }} key={index}>
                            <div className='text-[12px]' style={{ color: filter === item ? '#9B8C6F' : '#717171' }}>{item}</div>
                            <div className='' style={{ width: 31, height: 1, marginTop: 6, backgroundColor: filter === item ? '#9B8C6F' : 'transparent' }} />
                        </div>
                    )}
                </div>}






                <div className='w-full p-[16px] flex flex-row' style={{ gap: 16 }}>
                    <div className='flex flex-1 flex-col'>
                        {filteredProducts.map((item, index) =>
                            index % 2 === 1 ? <div key={item?._id} /> :
                                <div key={item?._id || index} style={{ width: '100%' }}
                                    className='relative flex flex-col flex flex-col items-center mr-[12px] border border-white border-[.5px] rounded-xl mb-[16px]'
                                >
                                    <div className='absolute bottom-0 left-0 right-0 top-0 rounded-xl' style={{ background: 'linear-gradient(180deg, #FFFFFF10 70%, #FFFFFF 100%)' }} />
                                    <img src={item?.thumbnail || item?.img} className='rounded-xl' style={{ objectFit: 'cover', height: undefined, width: '100%', aspectRatio: 1, borderRadius: 8 }} />
                                    <div className='flex relative w-full flex-col p-[4px] pb-[12px]' style={{}}>
                                        <div className='text-black text-[12px] py-[8px] font-normal'>{item.name || item?.label || '-'}</div>
                                        {item?.subtitle && <div className='text-[#425457] text-[10px] pb-[2px] font-normal'>{item.subtitle}</div>}
                                        <div className='flex relative w-full flex-row items-center gap-[4px]'>
                                            <CreditSvg size={16} />
                                            <div className='text-[#1C3D70] font-bold text-[20px]'>{item?.price || ''}</div>
                                        </div>
                                    </div>
                                </div>)
                        }
                    </div>
                    {filteredProducts.length===0&&
                        <div className='flex justify-center items-center py-[24px]'>
                            <img className='w-[205px] h-[168px]' src='https://t-gather.s3.ap-southeast-1.amazonaws.com/images/shops/comingsoon.png'/>
                        </div>
                    }
                    <div className='flex flex-1 flex-col'>
                        {filteredProducts.map((item, index) => 
                            index%2===0?<div key={item?._id}/>:
                            <div  key={item?._id||index} style={{width:  '100%'  }} 
                                className='relative flex flex-col flex flex-col items-center mr-[12px] border border-white border-[.5px] rounded-xl mb-[16px]'
                                
                            >
                                <div className='absolute bottom-0 left-0 right-0 top-0 rounded-xl' style={{ background: 'linear-gradient(180deg, #FFFFFF10 70%, #FFFFFF 100%)' }} />
                                <img src={item?.thumbnail||item?.img} className='rounded-xl' style={{objectFit:'cover', height:undefined,width:'100%',aspectRatio:1,borderRadius:8}}/>
                                <div className='relative w-full flex-col p-[4px] pb-[12px]' style={{}}>
                                    <div className='text-black text-[12px] py-[8px] font-normal'>{item.name||item?.label||'-'}</div>
                                    {item?.subtitle&& <div className='text-[#425457] text-[10px] pb-[2px] font-normal'>{item.subtitle}</div>}
                                    <div className='relative flex w-full flex-row items-center gap-[4px]'>
                                        <CreditSvg size={16}/>
                                        <div className='text-[#1C3D70] font-bold text-[20px]'>{item?.price||''}</div>
                                    </div>
                                </div>
                            </div>)
                        }
                    </div>
                </div>

                <div className='w-full h-[250px]' />







            </div>
        </div>
    )
}


const BackSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={13}
        height={18}
        fill="none"
        {...props}
    >
        <path
            stroke="#8D876C"
            strokeLinecap="round"
            strokeWidth={2}
            d="M11.852 1 2.163 7.812a1 1 0 0 0 0 1.636l9.69 6.813"
        />
    </svg>
)


const StarSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.size || 25}
        height={undefined}
        style={{ aspectRatio: 25 / 23 }}
        viewBox="0 0 25 23"
        fill="none"
        {...props}
    >
        <path
            stroke="#8D876C"
            d="M12.024 1.082a.5.5 0 0 1 .917-.081l.035.081 2.08 6.4a1.5 1.5 0 0 0 1.305 1.033l.121.005h6.73a.5.5 0 0 1 .361.846l-.066.058-5.446 3.956a1.5 1.5 0 0 0-.578 1.56l.034.117 2.08 6.401a.5.5 0 0 1-.696.605l-.074-.045-5.445-3.957a1.5 1.5 0 0 0-1.663-.067l-.1.067-5.446 3.957a.5.5 0 0 1-.79-.474l.02-.086 2.08-6.401a1.5 1.5 0 0 0-.45-1.602l-.095-.075-5.445-3.956a.5.5 0 0 1 .207-.898l.087-.006h6.73a1.5 1.5 0 0 0 1.385-.923l.042-.115 2.08-6.4Z"
        />
    </svg>
)

const ShoppingBagSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        fill="none"
        {...props}
    >
        <rect width={19} height={15} x={0.5} y={8.5} stroke="#8D876C" rx={1.5} />
        <path
            stroke="#8D876C"
            d="M5 12V5.259c0-.172.02-.343.074-.506C5.538 3.363 7.092 1 10.264 1c3.368 0 4.56 2.667 4.736 4v7"
        />
        <circle cx={20} cy={4} r={4} fill="#2D9797" />
    </svg>
)

const DownArrowSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={13}
        height={12}
        fill="none"
        {...props}
    >
        <path fill="#938474" d="M6.5 12 .005.75h12.99L6.5 12Z" />
    </svg>
)


const CreditSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={18}
        fill="none"
        {...props}
    >
        <path
            fill="url(#a)"
            d="M8.864.136A8.863 8.863 0 0 0 0 9a8.863 8.863 0 0 0 8.864 8.863V.136Z"
        />
        <path
            fill="#fff"
            stroke="#C7C7C7"
            strokeMiterlimit={10}
            strokeWidth={0.5}
            d="M15.75 9a6.75 6.75 0 1 1-13.5 0 6.75 6.75 0 0 1 13.5 0Z"
        />
        <path
            fill="url(#b)"
            fillRule="evenodd"
            d="M8 5H5v2h3v6h2V7h3V5H8Z"
            clipRule="evenodd"
        />
        <defs>
            <linearGradient
                id="a"
                x1={0.364}
                x2={8.964}
                y1={7.665}
                y2={8.475}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8C866B" />
                <stop offset={0.29} stopColor="#7D7649" />
                <stop offset={0.505} stopColor="#DDCFA2" />
                <stop offset={0.69} stopColor="#A59A87" />
                <stop offset={0.895} stopColor="#8C866B" />
            </linearGradient>
            <linearGradient
                id="b"
                x1={9}
                x2={9}
                y1={5}
                y2={13}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#8C866B" />
                <stop offset={0.14} stopColor="#8F896D" stopOpacity={0.96} />
                <stop offset={0.32} stopColor="#999274" stopOpacity={0.84} />
                <stop offset={0.53} stopColor="#C3B892" />
                <stop offset={0.76} stopColor="#BFB698" />
                <stop offset={1} stopColor="#B3AB93" />
            </linearGradient>
        </defs>
    </svg>
)